import { getPageContent } from "../api/content";
import {
  findPageSection,
  unwrapSectionData,
} from "../utils/aboutStartNewProjectSection";

export const normalizePublicLanguage = (language) =>
  String(language || "en").toLowerCase().split("-")[0];

export async function safeGetPageContent({ page, language }) {
  try {
    const data = await getPageContent({ page, language });
    return data && typeof data === "object" ? data : {};
  } catch {
    return {};
  }
}

export async function fetchPageContentWithAliases(aliases, language) {
  const lang = normalizePublicLanguage(language);
  for (const page of aliases) {
    const data = await safeGetPageContent({ page, language: lang });
    if (data && Object.keys(data).length) return data;
  }
  return {};
}

const PRODUCTS_PAGE_ALIASES = ["allproducts", "all-products", "products", "allproduct"];

export async function fetchProductsExploreSection(language) {
  const lang = normalizePublicLanguage(language);
  for (const page of PRODUCTS_PAGE_ALIASES) {
    try {
      const data = await getPageContent({ page, language: lang });
      if (!data || typeof data !== "object" || !Object.keys(data).length) continue;
      const section =
        findPageSection(data, "explore") ||
        findPageSection(data, "allproductsexplore") ||
        findPageSection(data, "ourproducts") ||
        findPageSection(data, "otherproducts");
      if (section) return unwrapSectionData(section);
    } catch {
      // try next alias
    }
  }
  return null;
}
